module.exports = __webpack_public_path__ + "static/media/27.b5af5740.mp3";